<!-- 获取Webhook引导 -->
<template>
  <Dialog
    v-model:show="dialogVisible"
    align-center
    :show-close="false"
    title="如何获取 Webhook 地址"
    width="800px"
  >
    <template #header>
      <div class="header">
        <h3 class="font-bold header-text text-color-main text-normal-4">如何获取 Webhook 地址</h3>
        <i class="icon-close-large-line t-iconfont text-color-auxiliary" @click="closeDialog"></i>
      </div>
    </template>
    <!-- 渠道导航栏 -->
    <div class="channel">
      <el-segmented v-model="guideChannel" :options="channelOptions" size="large">
        <template #default="scope">
          <div class="wrapper">
            <img alt="" :src="scope.item.img" />
            <span class="text-normal-4">{{ scope.item.label }}</span>
          </div>
        </template>
      </el-segmented>
    </div>

    <!-- 引导内容 -->
    <div class="guide hide-scrollbar">
      <div v-for="(step, index) in guideData" :key="step.id" class="guide__item">
        <h4 class="font-bold guide__item-title text-color-main text-normal-4">
          {{ index + 1 }}. {{ step.title }}
        </h4>
        <!-- 适配最小高度，使页面整齐排版 -->
        <p class="text-color-auxiliary text-normal-6" style="min-height: 32px">
          {{ step.description }}
        </p>
        <template v-for="(img, i) in step.imgList" :key="i">
          <el-image
            class="guide__item-img"
            fit="contain"
            :initial-index="i"
            :preview-src-list="step.imgList"
            :src="img"
          >
          </el-image>
        </template>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import { ref, computed } from 'vue'
import Dialog from '@/components/ai-dialog/index.vue'
import { getPreviewData } from '../../composables/usePromptConfig'

const guideData = computed(() => getPreviewData(guideChannel.value) || [])

const emits = defineEmits(['update:show'])
const props = defineProps({
  // 对话框显示状态
  show: {
    type: Boolean,
    default: false
  }
})

// 渠道
const guideChannel = ref('weCom')
// 渠道选项
const channelOptions = ref([
  {
    value: 'weCom',
    label: '企微',
    icon: 'icon-ai-generate-2',
    img: require('@/assets/weCom_colorful.svg'),
    disabled: false
  },
  {
    value: 'dingTalk',
    label: '钉钉',
    icon: 'icon-building-line',
    img: require('@/assets/dingtalk_colorful.svg'),
    disabled: false
  },
  {
    value: 'feiShu',
    label: '飞书',
    icon: 'icon-feishu-line',
    img: require('@/assets/feishu_colorful.svg'),
    disabled: false
  }
])

// 计算属性-本地对话框显示状态
const dialogVisible = computed({
  get: () => props.show,
  set: (val) => emits('update:show', val)
})
/**
 * 关闭对话框
 */
const closeDialog = () => {
  dialogVisible.value = false
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &-text {
    font-size: 18px;
  }

  .icon-close-large-line {
    padding: 4px;
    background-color: transparent;
    border-radius: 8px;
    font-weight: 500;
    cursor: pointer;

    &:hover {
      background: #f2f3f5;
    }
  }
}
.guide {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  height: 592px;
  overflow-y: scroll;
  margin: -12px;

  .font-bold {
    font-weight: bold;
  }

  &__item {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 364px;
    margin: 12px;

    &-title {
      margin-bottom: 4px;
    }

    &-img {
      width: 100%;
      height: 280px;
      box-sizing: border-box;
      border-radius: 8px;
      // border: 1px solid #e5e6eb;
      margin-top: 12px;
    }
  }
}

.channel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 24px;

  .el-segmented {
    --el-segmented-bg-color: #f7f8fa;
    --el-segmented-item-selected-color: #323233;
    --el-segmented-item-selected-bg-color: #fff;
    --el-border-radius-base: 8px;
    --el-segmented-padding: 4px;
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .t-iconfont {
      margin-right: 4px;
    }
  }
}
</style>
